import React from 'react';

import NoticeBar from 'common/uiV3/Composite/NoticeBar';
import isCore from 'common/util/isCore';
import isGrowth from 'common/util/isGrowth';
import isPro from 'common/util/isPro';
import isStarter from 'common/util/isStarter';

import type { Company } from 'common/api/endpoints/companies';

const AdminV2TrialNotice = ({ plan }: { plan: NonNullable<Company['trialingPlan']> }) => {
  const trialEndMilliseconds = new Date(plan.end).getTime();
  const nowMilliseconds = new Date().getTime();

  const dayMilliseconds = 1000 * 60 * 60 * 24;
  const millisecondsTilTrialEnds = trialEndMilliseconds - nowMilliseconds;
  const daysTilTrialEnds = Math.round(millisecondsTilTrialEnds / dayMilliseconds);
  const dayOrDays = daysTilTrialEnds === 1 ? 'day' : 'days';

  let planName = 'plan';
  if (plan.planID === 'business-trial-1') {
    planName = 'Business';
  } else if (isGrowth(plan.planID)) {
    planName = 'Growth';
  } else if (isStarter(plan.planID)) {
    planName = 'Starter';
  } else if (isCore(plan.planID)) {
    planName = 'Core';
  } else if (isPro(plan.planID)) {
    planName = 'Pro';
  }

  return (
    <NoticeBar
      message={`${daysTilTrialEnds} ${dayOrDays} left on your ${planName} trial`}
      action={{
        type: 'link',
        label: 'Upgrade',
        to: '/admin/settings/billing/subscription',
      }}
    />
  );
};

export default AdminV2TrialNotice;
